<template>
    <div>
        <rkm-form v-if="model" ref="Search">
            <rkm-row>
                <rkm-col>
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Data inicial"
                        end-label="Data final"
                        v-model="model.busca"
                        :start-validations="{ required: true }"
                        :end-validations="{ required: true }"
                        right
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        label="Status"
                        :options="form.status"
                        v-model="model.status"
                        text-field="text"
                        value-field="value"
                        default-option-text="Todos"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="search()"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="clear"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-row v-if="items.length > 0">
            <rkm-col>
                <rkm-button
                    @click="() => !selecionados ? desmarcarSelecionados() : selecionarTodos()"
                    color="primary"
                    class="mb-2"
                >
                    <template v-if="selecionados">
                        Selecionar todos
                    </template>

                    <template v-else>
                        Desmarcar selecionado(s)
                    </template>
                </rkm-button>

                <template>
                    <rkm-button
                        v-if="!selecionados"
                        @click="agendarSelecionados()"
                        color="info"
                        class="mb-2"
                    >
                        Agendar selecionado(s)
                    </rkm-button>
                    <rkm-button
                        v-if="!selecionados"
                        @click="deletarSelecionados()"
                        color="danger"
                        class="mb-2"
                    >
                        Excluir selecionado(s)
                    </rkm-button>
                </template>

                <rkm-button
                    v-if="!selecionados"
                    @click="openModal()"
                    class="mb-2"
                >
                    Atribuir horario a selecionados
                </rkm-button>
            </rkm-col>
        </rkm-row>

        <rkm-form ref="Form" v-if="items.length > 0">
            <rkm-table
                :fields="fields"
                :items="items"
                :sort-compare="sortCompare"
                :tbody-tr-attr="handleRowAttr"
                sort-by="preAgendamentoData"
                class="table-agendamentos"
                responsive
            >
                <template v-slot:cell(checkbox)="{ item }">
                    <rkm-form-checkbox
                        v-model="item.selecionado"
                    />
                </template>

                <template v-slot:cell(preAgendamentoData)="{ item }">
                    {{ item.preAgendamentoData | formatDate }} às {{ item.preAgendamentoHorario | formatTime }}
                </template>

                <template v-slot:cell(agendarDataSaida)="{ item }">
                    <rkm-form-date-picker
                        name="Data de saída"
                        v-model="item.dataSaida"
                        @input="handleChangeDataSaida(item)"
                        :disabled="item.agendarId !== null"
                        :max-date="item.preAgendamentoData"
                        class="mb-0"
                    />
                </template>

                <template v-slot:cell(agendarHorarioSaida)="{ item }">
                    <rkm-form-time-picker
                        name="Horário de saída"
                        v-model="item.horarioSaida"
                        right
                        :disabled="!item.dataSaida"
                        @input="item.horarioSaida ? handleChangeHorarioSaida(item) : handleChangeHorarioSaida(item)"
                        :validations="validationsHorarioSaida(item)"
                        class="mb-0"
                    />
                </template>

                <template v-slot:cell(transportePacienteVeiculo)="{ item }">
                    <rkm-form-select
                        v-if="item.jaAgendado == null"
                        :options="(item.veiculos == null || item.veiculos == '') ? form.veiculos : item.veiculos"
                        :disabled="!item.horarioSaida"
                        :validations="validationsVeiculo"
                        name="Veículo"
                        text-field="descricao"
                        value-field="id"
                        v-model="item.veiculoId"
                        class="mb-0"
                        show-default-option
                        @input="handleChangeVeiculo(item)"
                    />
                    <rkm-form-input
                        v-else
                        v-model="item.veiculoDescricao"
                        class="mb-0"
                        disabled
                    />
                </template>

                <template v-slot:cell(transportePacienteJornada)="{ item }">
                    <rkm-form-select
                        v-if="item.jaAgendado == null"
                        :options="(item.jornadas == null || item.jornadas == '') ? form.jornadas : item.jornadas"
                        :disabled="!item.veiculoId"
                        :validations="validationsJornada"
                        name="Jornada"
                        text-field="descricao"
                        value-field="id"
                        v-model="item.jornadaId"
                        class="mb-0"
                        show-default-option
                        @input="handleChangeJornada(item)"
                    />
                    <rkm-form-input
                        v-else
                        v-model="item.jornadaDescricao"
                        class="mb-0"
                        disabled
                    />
                </template>

                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        @click="agendar(item)"
                        color="info"
                        small
                        title="Agendar"
                    >
                        <rkm-icon icon="calendar"/>
                    </rkm-button>

                    <rkm-button
                        @click="handleDestroy(item)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>

            <rkm-row class="mt-2">
                <rkm-col>
                    <p class="m-0">
                        A linha em <span class="blue">azul</span> representa que o pré-agendamento foi utilizado para
                        criar um agendamento.
                    </p>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <Modal
            ref="Modal"
            @atribuir="atribuitHorario"
        />
    </div>
</template>

<script>
import Modal from '@/components/transporte-paciente/pre-agendamento-transporte/components/buscar/components/Modal'
import status from "@/enums/transporte-paciente/agendar-transporte/status";
import { repository, error, object, data, stringCase } from '@/mixins'
import format from "@/filters/formats";
import { mapActions } from "vuex";
import moment from "moment";

export default {
    components: {
        Modal
    },
    filters: {
        ...format
    },
    created() {
        this.repositories = {
            preAgendamentoTransporte: this.getConectaSusRepository("transportePaciente.preAgendamentoTransporte"),
            agendar: this.getConectaSusRepository('transportePaciente.agendar')
        }
        this.items = this.agendamentos.map(agendamento => {
            return { ...agendamento }
        })
    },
    computed: {
        validationsHorarioSaida() {
            return (item) => {

                const dataSaida = (typeof item.dataSaida == 'string') ? item.dataSaida : moment(item.dataSaida).format('YYYY-MM-DD')

                return {
                    max_hour: moment(item.preAgendamentoData, 'DD/MM/YYYY').isSame(moment(dataSaida, 'YYYY-MM-DD'))
                        ? this.getMaxHour(item.preAgendamentoHorario)
                        : false
                }
            }
        },
        validationsVeiculo() {

            return {
                required: this.form.veiculoObrigatorio
            }
        },
        validationsJornada() {

            return {
                required: this.form.agendarTransporteJornada
            }
        },
        selecionados() {

            return this.items.filter(item => item.selecionado).length == 0
        },
        fields() {
            return [
                {
                    key: 'checkbox',
                    label: '#',
                    class: 'col-min text-center',
                },
                {
                    key: "municipio",
                    label: "Município",
                    name: "municio",
                    sortable: true,
                },
                {
                    key: "transportePacienteDestino",
                    label: "Destino",
                    name: "transportePacienteDestino",
                    sortable: true,
                },
                {
                    key: "transportePacienteMotivo",
                    label: "Motivo",
                    name: "transportePacienteMotivo",
                    sortable: true,
                },
                {
                    key: "preAgendamentoData",
                    label: "Data da consulta",
                    name: "preAgendamentoData",
                    class: "col-min text-center",
                    sortable: true,
                },
                {
                    key: "agendarDataSaida",
                    label: "Data de saída",
                    name: "agendarDataSaida",
                    class: 'col-saida',
                },
                {
                    key: "agendarHorarioSaida",
                    label: "Horário de saída",
                    name: "agendarHorarioSaida",
                    class: 'col-saida',
                },
                {
                    key: "transportePacienteVeiculo",
                    label: "Veículo",
                    name: "transportePacienteVeiculo",
                    class: 'col-veiculo',
                },
            ].concat(this.jornada ? [
                {
                    key: 'transportePacienteJornada',
                    label: 'Jornada',
                    name: 'TransportePacienteJornada',
                    class: 'col-veiculo',
                }] : [],
                [{
                    class: "col-min text-center",
                    key: "actions",
                    label: "Ações"
                }])
        }
    },
    data: () => ({
        enums: { status },
        items: [],
    }),
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        openModal() {
            this.$refs.Modal.open()
        },
        atribuitHorario(horario) {
            this.items.forEach(item => {
                if(item.selecionado) {
                    item.horarioSaida = horario
                }
            })
        },
        sortCompare(a, b, key) {

            if (key === 'preAgendamentoData') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        add(items) {
            this.items = this.items.concat(items)
        },
        search() {
            this.$refs.Search.validate().then(valid => {
                if(!valid) return
                this.setLoading()
                this.repositories.preAgendamentoTransporte.search({
                    'data_inicial': moment(this.model.busca.start).format('YYYY-MM-DD'),
                    'data_final': moment(this.model.busca.end).format('YYYY-MM-DD'),
                    'paciente_id': this.id,
                    'status': this.model.status,
                })
                    .then(({data}) => {
                        this.items = data.map(d => {
                            d.preAgendamentoHorario = d.preAgendamentoHorario.slice(0,5)
                            d.veiculos = []
                            if(this.jornada) {
                                d.jornadas = []
                            }
                            return d
                        })
                        this.items.forEach((item, index) => {
                            if(item.dataSaida && item.horarioSaida) {
                                this.getVeiculos(index, item.dataSaida, item.horarioSaida)
                            }
                            if(this.jornada && item.veiculoId) {
                                this.getJornadas(index, item.veiculoId, moment(`${item.dataSaida} ${item.horarioSaida}`).format('YYYY-MM-DD HH:mm'))
                            }
                        })
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
                })
        },
        selecionarTodos() {
            this.items = this.items.map(item => {
                item.selecionado = true
                return item
            })
        },
        desmarcarSelecionados() {
            this.items = this.items.map(item => {
                item.selecionado = false
                return item
            })
        },
        handleDestroy(item) {

            this.showDeleteConfirmation('Deseja realmente excluir o agendamento?', async () => this.excluirAgendamento(item))
        },
        excluirAgendamento(item) {
            this.setLoading()

            const index = this.items.findIndex((obj => obj.id == item.id));

            this.repositories.preAgendamentoTransporte.destroy(this.items[index].id)
                .then(() => {
                    this.$emit('remove', this.items[index].id)
                    this.items.splice(index, 1)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        deletarSelecionados() {
            const confirm = async () => {
                this.setLoading()
                const selected = this.items.filter(item => (item.selecionado)).map(item => (item.id))
                this.repositories.preAgendamentoTransporte.destroyAll(selected)
                    .then(() => {
                        this.$emit('removeSelected', selected)
                        this.items = this.items.filter(item => (!item.selecionado))
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
            this.showDeleteConfirmation('Deseja realmente excluir os agendamentos selecionados?', async () => confirm())
        },
        agendar(item) {

            if(item.agendarId === null) {

                const veiculo = item.veiculos.find(v => v.id == item.veiculoId);

                if (moment(item.preAgendamentoData).isSame(moment(item.dataSaida)) &&
                    item.horarioSaida > this.getMaxHour(item.preAgendamentoHorario)) {

                        this.showAlert(`O horário de saída deve ser menor ou igual à
                            ${this.getMaxHour(item.preAgendamentoHorario)}.` , 'Atenção')
                } else if (this.form.veiculoObrigatorio && !item.veiculoId) {

                    this.showAlert('É obrigatório informar o veículo.', 'Atenção')
                } else if (this.form.agendarTransporteJornada && item.veiculoId && !item.jornadaId) {

                    this.showAlert('É obrigatório informar a jornada.', 'Atenção')
                } else {

                    const totalAgendados = veiculo.agendados !== null ? veiculo.agendados.quantidade : (veiculo.totalAgendados ? veiculo.totalAgendados : undefined)
                    const acompanhante = item.acompanhante
                    const capacidade = veiculo.capacidade ? veiculo.capacidade : undefined

                    if ((parseInt(totalAgendados) + parseInt(acompanhante) + 1) >  parseInt(capacidade)) {

                        this.showAlert(`A capacidade do veículo já foi atingida, escolha outro veículo.`, 'Atenção')
                        return
                    } else {

                        const confirm = async () => {

                            this.setLoading()
                            this.repositories.agendar.store(this.prepareData(item))
                                .then((response) => {

                                    const index = this.items.findIndex((agendar) => agendar.id === item.id)
                                    this.items[index].agendarId = response.data.id
                                    this.items[index].veiculoDescricao = item.veiculos.find(veiculo => veiculo.id == item.veiculoId)?.descricao ?? null
                                    this.items[index].jornadaDescricao = item.jornadas.find(jornada => jornada.id == item.jornadaId)?.descricao ?? null
                                    this.items[index].selecionado = false
                                    this.$emit('remove', this.items[index].id)
                                    this.items.splice(index, 1)

                                    this.showSaveNotification()
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        }

                        this.showConfirmation('Deseja realmente agendar o pré-agendamento?', async () => confirm())
                    }
                }
            } else {

                const veiculo = item.veiculos.find(v => v.id == item.veiculoId)

                if (moment(item.preAgendamentoData).isSame(moment(item.dataSaida)) &&
                    item.horarioSaida > this.getMaxHour(item.preAgendamentoHorario)) {

                        this.showAlert(`O horário de saída deve ser menor ou igual à
                            ${this.getMaxHour(item.preAgendamentoHorario)}.` , 'Atenção')
                } else if (this.form.veiculoObrigatorio && !item.veiculoId) {

                    this.showAlert('É obrigatório informar o veículo.', 'Atenção')
                } else if (this.form.agendarTransporteJornada && item.veiculoId && !item.jornadaId) {

                    this.showAlert('É obrigatório informar a jornada.', 'Atenção')
                } else {

                    const totalAgendados = veiculo.agendados !== null ? veiculo.agendados.quantidade : (veiculo.totalAgendados ? veiculo.totalAgendados : 0)
                    const acompanhante = item.acompanhante || 0
                    const capacidade = veiculo.capacidade || 0

                    if ((parseInt(totalAgendados) + parseInt(acompanhante) + 1) >  parseInt(capacidade)) {

                        this.showAlert(`A capacidade do veículo já foi atingida, escolha outro veículo.`, 'Atenção')
                        return
                    } else {
                        const confirm = async () => {

                            this.setLoading()
                            this.repositories.agendar.update(this.prepareData(item))
                                .then((response) => {

                                    const index = this.items.findIndex((agendar) => agendar.id === item.id)
                                    this.items[index].agendarId = response.data.id
                                    this.items[index].veiculoDescricao = item.veiculos.find(veiculo => veiculo.id == item.veiculoId)?.descricao ?? null
                                    this.items[index].jornadaDescricao = item.jornadas.find(jornada => jornada.id == item.jornadaId)?.descricao ?? null
                                    this.items[index].selecionado = false
                                    this.$emit('remove', this.items[index].id)
                                    this.items.splice(index, 1)

                                    this.showSaveNotification()
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        }

                        this.showConfirmation('Deseja realmente agendar o pré-agendamento?', async () => confirm())
                    }
                }
            }
        },
        agendarSelecionados() {

            const error = this.validateItemsSelecionados();

            if (error) {
                return
            }

            const confirm = async () => {

                this.items.filter(item => (item.selecionado)).forEach(item => {

                    if (item.agendarId === null || item.agendarId === '' || item.agendarId === undefined) {

                        this.setLoading()
                        this.repositories.agendar.store(this.prepareData(item))
                            .then((response) => {

                                const index = this.items.findIndex((agendar) => agendar.id === item.id)
                                this.items[index].agendarId = response.data.id
                                this.items[index].selecionado = false
                                this.$emit('remove', this.items[index].id)
                                this.items.splice(index, 1)

                                this.showSaveNotification()
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    } else {

                        this.setLoading()
                        this.repositories.agendar.update(this.prepareData(item))
                            .then((response) => {

                                const index = this.items.findIndex((agendar) => agendar.id === item.id)
                                this.items[index].agendarId = response.data.id
                                this.items[index].selecionado = false
                                this.$emit('remove', this.items[index].id)
                                this.items.splice(index, 1)

                                this.showSaveNotification()
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
            }

            this.showConfirmation('Deseja realmente agendar o(s) pré-agendamento(s) selecionado(s)?', async () => confirm())
        },
        agendarTodos() {

            const error = this.validateItems();

            if (error) {
                return
            }

            const confirm = async () => {

                this.items.forEach(item => {

                    if (item.jornadaId) {

                        if (item.agendarId === null || item.agendarId === '' || item.agendarId === undefined) {

                            this.setLoading()
                            this.repositories.agendar.store(this.prepareData(item))
                                .then((response) => {

                                    const index = this.items.findIndex((agendar) => agendar.id === item.id)
                                    this.items[index].agendarId = response.data.id
                                    this.items[index].selecionado = false
                                    this.$emit('remove', this.items[index].id)
                                    this.items.splice(index, 1)

                                    this.showSaveNotification()
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        } else {

                            this.setLoading()
                            this.repositories.agendar.update(this.prepareData(item))
                                .then((response) => {

                                    const index = this.items.findIndex((agendar) => agendar.id === item.id)
                                    this.items[index].agendarId = response.data.id
                                    this.items[index].selecionado = false
                                    this.$emit('remove', this.items[index].id)
                                    this.items.splice(index, 1)

                                    this.showSaveNotification()
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        }
                    }
                })
            }

            this.showConfirmation('Deseja realmente agendar o(s) pré-agendamento(s)?', async () => confirm())
        },
        validateItems() {
            const errors = []
            const jornadaTotals = {}

            this.items.forEach(item => {

                if (item.jornadaId) {

                    const veiculo = item.veiculos.find(v => v.id == item.veiculoId)

                    if (moment(item.preAgendamentoData).isSame(moment(item.dataSaida)) &&
                        item.horarioSaida > this.getMaxHour(item.preAgendamentoHorario)) {

                        errors.push(`Na viagem do dia ${moment(item.preAgendamentoData).format('DD/MM/YYYY')} às ${moment(item.preAgendamentoHorario, 'HH:mm').format('HH:mm')}, o horário de saída deve ser menor ou igual à ${this.getMaxHour(item.preAgendamentoHorario)}.`)
                    } else if (this.form.agendarTransporteJornada && item.veiculoId && item.jornadaId) {

                        const totalAgendados = veiculo.agendados !== null ? veiculo.agendados.quantidade : (veiculo.totalAgendados ? veiculo.totalAgendados : 0)
                        const acompanhante = item.acompanhante || 0
                        const capacidade = veiculo.capacidade || 0

                        if (!jornadaTotals[item.jornadaId]) {

                            jornadaTotals[item.jornadaId] = 0
                        }

                        const totalAtual = parseInt(jornadaTotals[item.jornadaId]) + parseInt(totalAgendados) + parseInt(acompanhante) + 1

                        if (totalAtual > parseInt(capacidade)) {

                            errors.push(`Na viagem do dia ${moment(item.preAgendamentoData).format('DD/MM/YYYY')} às ${moment(item.preAgendamentoHorario, 'HH:mm').format('HH:mm')}, a capacidade do veículo já foi atingida, escolha outro veículo.`)
                        } else {

                            jornadaTotals[item.jornadaId] = totalAtual
                        }
                    }
                }
            })

            if (errors.length > 0) {

                const errorMessage = errors.join('<br>');
                this.showAlert(errorMessage, 'Atenção');
                return true
            }

            return false
        },
        validateItemsSelecionados() {
            const errors = []
            const jornadaTotals = {}

            this.items.forEach(item => {

                const veiculo = item.veiculos.find(v => v.id == item.veiculoId);

                if (moment(item.preAgendamentoData).isSame(moment(item.dataSaida)) &&
                    item.horarioSaida > this.getMaxHour(item.preAgendamentoHorario)) {

                    errors.push(`Na viagem do dia ${moment(item.preAgendamentoData).format('DD/MM/YYYY')} às ${moment(item.preAgendamentoHorario, 'HH:mm').format('HH:mm')}, o horário de saída deve ser menor ou igual à ${this.getMaxHour(item.preAgendamentoHorario)}.`)
                } else if (this.form.veiculoObrigatorio && !item.veiculoId) {

                    errors.push(`Na viagem do dia ${moment(item.preAgendamentoData).format('DD/MM/YYYY')} às ${moment(item.preAgendamentoHorario, 'HH:mm').format('HH:mm')}, é obrigatório informar o veículo.`)
                } else if (this.form.agendarTransporteJornada && item.veiculoId && !item.jornadaId) {

                    errors.push(`Na viagem do dia ${moment(item.preAgendamentoData).format('DD/MM/YYYY')} às ${moment(item.preAgendamentoHorario, 'HH:mm').format('HH:mm')}, é obrigatório informar a jornada.`)
                } else if (this.form.agendarTransporteJornada && item.veiculoId && item.jornadaId) {

                    const totalAgendados = veiculo.agendados !== null ? veiculo.agendados.quantidade : (veiculo.totalAgendados ? veiculo.totalAgendados : 0)
                    const acompanhante = item.acompanhante || 0
                    const capacidade = veiculo.capacidade || 0

                    if (!jornadaTotals[item.jornadaId]) {

                        jornadaTotals[item.jornadaId] = 0
                    }

                    const totalAtual = parseInt(jornadaTotals[item.jornadaId]) + parseInt(totalAgendados) + parseInt(acompanhante) + 1

                    if (totalAtual > parseInt(capacidade)) {

                        errors.push(`Na viagem do dia ${moment(item.preAgendamentoData).format('DD/MM/YYYY')} às ${moment(item.preAgendamentoHorario, 'HH:mm').format('HH:mm')}, a capacidade do veículo já foi atingida, escolha outro veículo.`)
                    } else {

                        jornadaTotals[item.jornadaId] = totalAtual
                    }
                }
            })

            if (errors.length > 0) {

                const errorMessage = errors.join('<br>');
                this.showAlert(errorMessage, 'Atenção');
                return true
            }

            return false
        },
        prepareData(item) {

            const veiculo = item.veiculos.find(v => v.id == item.veiculoId) ?? null;

            return this.camelObjectKeysToSnakeRecursive({
                agendarId: item.agendarId ? item.agendarId : undefined,
                preAgendamentoId: item.id,
                pacienteId: item.pacienteId,
                motivoId: item.motivoId,
                horario: item.preAgendamentoHorario,
                data: moment(item.preAgendamentoData).format('YYYY-MM-DD'),
                municipioId: item.municipioId,
                destinoId: item.destinoId,
                acompanhante: item.acompanhante,
                acompanhante1: item.acompanhante >= 1 ? {
                    usuario_id: item.acompanhante1,
                    relacao: item.relacao1,
                    nome: item.nome1
                } : undefined,
                acompanhante2: item.acompanhante >=2 ? {
                    usuario_id: item.acompanhante2,
                    relacao: item.relacao2,
                    nome: item.nome2
                } : undefined,
                pontoId: item.pontoId,
                consultaObservacao: item.observacao,
                dataSaida: item.dataSaida ? moment(item.dataSaida).format('YYYY-MM-DD') : item.preAgendamentoData,
                horarioSaida: item.horarioSaida ? item.horarioSaida : undefined,
                veiculoId: item.veiculoId ? item.veiculoId : undefined,
                jornadaId: item.jornadaId ? item.jornadaId : undefined,
                statusId: this.enums.status.AGENDADO,
                tipoPassageiroId: item.tipoPassageiroId,
                tipoVeiculoId: veiculo ? veiculo.tipoVeiculoId : undefined
            })
        },
        handleChangeDataSaida(item) {

            this.handleChangeHorarioSaida(item)
        },
        handleChangeHorarioSaida(item) {

            const index = this.items.findIndex((obj => obj.id == item.id));

            if(this.items[index].dataSaida && this.items[index].horarioSaida) {
                this.items[index].veiculoId = null
                if(this.jornada) {
                    this.items[index].jornadaId = null
                }
                this.getVeiculos(index, item.dataSaida, item.horarioSaida)
            }
        },
        handleChangeVeiculo(item) {

            const index = this.items.findIndex((obj => obj.id == item.id));

            if(this.items[index].veiculoId) {

                if(this.jornada) {
                    this.items[index].jornadaId = null
                }

                const dataSaida = (typeof item.dataSaida == 'string') ? item.dataSaida : moment(item.dataSaida).format('YYYY-MM-DD')

                this.items[index].veiculoDescricao = item.veiculos.find(veiculo => veiculo.id == item.veiculoId)?.descricao ?? null

                this.getJornadas(index, item.veiculoId, moment(`${dataSaida} ${item.horarioSaida}`).format('YYYY-MM-DD HH:mm'))
            }
        },
        handleChangeJornada(item) {

            const index = this.items.findIndex((obj => obj.id == item.id))

            if(this.items[index].jornadaId) {

                this.items[index].jornadaDescricao = item.jornadas.find(jornada => jornada.id == item.jornadaId)?.descricao ?? null
            }
        },
        getVeiculos(index, dataSaida, horarioSaida) {

            this.setLoading()

            this.repositories.agendar.getVeiculos({
                agendar_transporte_jornada: this.jornada,
                data_saida: moment(dataSaida).format('YYYY-MM-DD'),
                horario_saida: horarioSaida
            })
                .then(({data}) => {
                    this.items[index].veiculos = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getJornadas(index, veiculo, dataHorarioSaida) {

            if(this.jornada) {

                this.setLoading()
                this.repositories.agendar.getJornadas({
                    veiculo_id: veiculo,
                    data_horario_saida: dataHorarioSaida
                })
                    .then(({data}) => {

                        if (data.length == 0) {

                            this.showAlert('Não existe jornada para o veículo selecionado.', 'Atenção')
                        } else {

                            this.$set(this.items[index], 'jornadas', data)

                            const primeiraJornada = data[0]
                            this.$set(this.items[index], 'jornadaId', primeiraJornada?.id || null)
                            this.$set(this.items[index], 'jornadaDescricao', primeiraJornada?.descricao || '')
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        getMaxHour(horario) {

            if (horario) {

                return moment(horario, 'HH:mm').subtract(1, 'minutes').format('HH:mm')
            }

            return false
        },
        handleRowAttr(item, type) {

            if (type === 'row') {

                if (item.agendarId !== null) {

                    return {
                        style: `
                            border-left: 10px solid #007bff;
                            background-color: #007bff15;
                        `
                    }
                }
            }
        },
        clear() {

            this.model.busca.start = null
            this.model.busca.end = null
            this.model.status = null
            this.items = []

            this.$nextTick().then(() => this.$refs.Search.resetValidator())
        },
        save() {

            this.agendarTodos()
        }
    },
    props: {
        id: { type: Number, default: null },
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        jornada: { type: Boolean, default: false },
        agendamentos: { type: Array, required: true },
    },
    mixins: [ repository, error, object, data, stringCase ],
    watch: {
        'model.busca.start': function () {

            this.items = []
        },
        'model.busca.end': function () {

            this.items = []
        },
        'model.status': function () {

            this.items = []
        }
    }
}
</script>

<style scoped>
.blue { color: blue; }
.table-agendamentos >>> .col-saida {
    min-width: 160px;
}
.table-agendamentos >>> .col-veiculo {
    min-width: 300px;
}
</style>